import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { CaptainShareRideService } from './captain-share-ride.service';

@Component({
  selector: 'captain-share-ride',
  template: require('./captain-share-ride.component.html')
})
export class CaptainShareRideComponent implements OnInit, OnDestroy {
  public data: any;
  public showData = true;
  public trackId = '';
  private subscriber: any;

  public rideCompleteImage = '../../../assets/img/track_unavailable.svg';
  public errorImage = '../../../assets/img/error-screen.png';
  public screenOrientationImage = '../../../assets/img/rotate.png';
  public rapidoWordmark = require('../../assets/rapido-wordmark.png');

  public lastUpdatedText = 'Updated just now';
  private lastUpdatedTimer: any;
  private pollIntervalMs = Number.parseInt(process.env.CAPTAIN_POLL_INTERVAL_MS, 10) || 5000;

  constructor(
    private service: CaptainShareRideService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.trackId = this.route.snapshot.params.id;
    this.fetchTrackingData(this.trackId);
  }

  fetchTrackingData(id: string) {
    this.service.getCaptainTrackingData(id).subscribe((result: any) => {
      if (!this.isValidResponse(result)) {
        this.showData = false;
        return;
      }
      this.showData = true;
      this.data = result;
      if (result.status === 'unavailable') return;
      this.data.setMapCenter = true;
      if (result.status === 'dropped') return;
      this.startLastUpdatedTimer();

      this.subscriber = Observable.interval(this.pollIntervalMs).subscribe(() => {
        this.service.getCaptainTrackingData(id).subscribe((result: any) => {
          if (!this.isValidResponse(result)) {
            this.showData = false;
            this.unsubscribe();
            return;
          }
          this.data = result;
          if (result.status === 'unavailable' || result.status === 'dropped') {
            this.unsubscribe();
            return;
          }
          this.data.setMapCenter = false;
          this.startLastUpdatedTimer();
        }, () => {
          this.showData = false;
          this.unsubscribe();
        });
      });
    }, () => {
      this.showData = false;
    });
  }

  get captainName(): string {
    const riderInfo = this.data && this.data.riderObj && this.data.riderObj.riderInfo;
    const name = riderInfo && riderInfo.name;
    return name ? String(name).trim() : '';
  }

  get vehicleNumber(): string {
    if (!this.data || !this.data.riderObj || !this.data.riderObj.vehicleObj) return '';
    return this.data.riderObj.vehicleObj.number;
  }

  private isValidResponse(result: any): boolean {
    if (!result || result.message) return false;
    if (result.status === 'unavailable') return true;
    return !!(result.status && result.riderObj);
  }

  private startLastUpdatedTimer() {
    this.lastUpdatedText = 'Updated just now';
    if (this.lastUpdatedTimer) clearInterval(this.lastUpdatedTimer);
    const stepSec = Math.round(this.pollIntervalMs / 1000) || 5;
    let seconds = 0;
    this.lastUpdatedTimer = setInterval(() => {
      seconds += stepSec;
      this.lastUpdatedText = seconds < 60
        ? `Updated ${seconds}s ago`
        : `Updated ${Math.floor(seconds / 60)}m ago`;
    }, this.pollIntervalMs);
  }

  private unsubscribe() {
    if (this.subscriber) this.subscriber.unsubscribe();
    if (this.lastUpdatedTimer) clearInterval(this.lastUpdatedTimer);
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
}
